import { Component } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
@Component({
  selector: 'app-no-show',
  imports: [ProgressSpinnerModule],
  templateUrl: './no-show.component.html',
  styleUrl: './no-show.component.scss',
})
export class NoShowComponent {
  constructor() {}
}
